export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7004.01c507f8.jpg";